import styled from 'styled-components'
import {
  background,
  border,
  color,
  compose,
  flex,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  typography,
  variant,
  system,
} from 'styled-system'

// General Addons
const boxStyle = variant({
  prop: 'boxStyle',
  scale: 'boxStyles',
})
const textStyle = variant({
  prop: 'textStyle',
  scale: 'textStyles',
})
const buttonStyle = variant({
  prop: 'buttonStyle',
  scale: 'buttonStyles',
})

// Image Addons
const objectFit = system({ objectFit: true })
const objectPosition = system({ objectPosition: true })

// Animation Addons
const transform = system({ transform: true })
const transition = system({ transition: true })

// Flex and Grid Addons
const alignContent = system({
  alignContent: true,
})
const alignSelf = system({ alignSelf: true })
const alignItems = system({ alignItems: true })
const placeSelf = system({ placeSelf: true })
const placeContent = system({ placeContent: true })
const placeItems = system({ placeItems: true })
const justifySelf = system({ justifySelf: true })
const justifyItems = system({
  justifyItems: true,
})
const justifyContent = system({ justifyContent: true })

const gridRow = system({ gridRow: true })
const gridColumn = system({ gridColumn: true })

// SVG addons
const fill = system({ fill: true })

// Input addons
const outline = system({ outline: true })

export const Box = styled.div(
  compose(
    // General Stuff
    space,
    color,
    layout,
    background,
    border,
    position,
    shadow,
    transform,
    transition,
    boxStyle,

    // Flex & Grid
    justifySelf,
    alignSelf,
    placeSelf,

    // Flex
    flex,

    // Grid,
    gridRow,
    gridColumn,
  ),
)

Box.defaultProps = {
  display: 'block',
}

export const Flex = styled(Box)(flexbox)

Flex.defaultProps = {
  display: 'flex',
}

export const Grid = styled(Box)(
  compose(
    grid,
    placeContent,
    placeItems,
    alignContent,
    alignItems,
    justifyContent,
    justifyItems,
  ),
)

Grid.defaultProps = {
  display: 'grid',
}

export const Image = styled(Box)(
  compose(
    objectFit,
    objectPosition,
  ),
)

Image.defaultProps = {
  as: 'img',
  display: 'block',
}

export const SVG = styled(Box)(p => ({
  '*': {
    ...fill(p),
  },
}))

export const Text = styled(Box)(
  compose(
    typography,
    textStyle,
  ),
)

export const Heading = styled(Text)({})

Heading.defaultProps = {
  as: 'h2',
}

export const Subheading = styled(Text)({})

Subheading.defaultProps = {
  as: 'h3',
}

export const Input = styled(Text)(outline)

Input.defaultProps = {
  as: 'input',
  display: 'block',
}

export const Button = styled(Text)(
  compose(
    outline,
    buttonStyle,
  ),
)

Button.defaultProps = {
  as: 'button',
  display: 'block',
}
